import { SET_COLUMNS, SET_IS_RESIZING, SET_LEFTOVER_COLUMN_WIDTH, SET_RESET_TO_SCROLL_TOP } from './constants';

/*
 * For all of the actions in this reducer, perform strict-equals value check
 * against the target data before performing the actual update. If there's no
 * actual change, just return the original state object, else, return a copy
 * of that state update with the change applied. This should prevent renders
 * from being triggered unnecessarily.
 */
const actionMap = {
  [SET_COLUMNS]: (state, { columns }) => {
    if (columns === state.columns) {
      return state;
    }

    return {
      ...state,
      columns,
    };
  },

  [SET_IS_RESIZING]: (state, { isResizing }) => {
    if (isResizing === state.isResizing) {
      return state;
    }

    return {
      ...state,
      isResizing,
    };
  },

  [SET_LEFTOVER_COLUMN_WIDTH]: (state, { leftoverColumnWidth }) => {
    if (leftoverColumnWidth === state.leftoverColumnWidth) {
      return state;
    }

    return {
      ...state,
      leftoverColumnWidth,
    };
  },

  [SET_RESET_TO_SCROLL_TOP]: (state, { resetToScrollTop }) => {
    if (resetToScrollTop === state.resetToScrollTop) {
      return state;
    }

    return {
      ...state,
      resetToScrollTop,
    };
  },
};

/*
 * React's useReducer hook doesn't have an 'init' phase like Redux does,
 * where it might seed the initial state according to functional defaults
 * here, so we don't bother applying default values to the parameters.
 * There is an 'init' parameter that can be used to seed the initial
 * data to the reducer's state object, and to which you could pass the
 * reducer function itself, but the syntax is ugly:
 *
 * const [state, dispatch] = useReducer(reducer, undefined, reducer);
 *
 * as opposed to
 *
 * const [state, dispatch] = useReducer(reducer, getInitialState());
 */
export const reducer = (state, action) => (actionMap[action.type] ? actionMap[action.type](state, action) : state);
